import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './App.css';
import { useTheme } from './ThemeContext';
import Swal from 'sweetalert2';

function MedicalRecordPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { theme } = useTheme();

  const { fetchedData } = location.state || {};
  
  if (!fetchedData) {
    Swal.fire({
      icon: 'error',
      title: 'No Record',
      text: 'No data available. Please access the record first.'
    });
    navigate('/');
    return null;
  }

  const renderRecordCreatedAt = () => {
    if (!fetchedData.addedAt) return 'N/A';
    if (fetchedData.addedAt?.seconds && fetchedData.addedAt?.nanoseconds) {
      // It's a Firestore Timestamp
      const date = new Date(fetchedData.addedAt.seconds * 1000);
      return date.toLocaleString();
    }
    if (fetchedData.addedAt.toDate) {
      // It's a Firestore Timestamp
      return fetchedData.addedAt.toDate().toLocaleString();
    }
    if (typeof fetchedData.addedAt === 'string') {
      const date = new Date(fetchedData.addedAt);
      return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleString();
    }
    return 'N/A';
  };
  
  return (
    <div className={`medical-record-page ${theme}`} style={styles.container}>
      <h1 style={styles.header}>
        {fetchedData.userType === 'Doctor' ? 'Doctor Details' : 'Electronic Health Record (EHR)'}
      </h1>
      <div style={styles.recordContainer}>
        <h2 style={styles.subHeader}>{fetchedData.fullName}</h2>

        {fetchedData.userType === 'Patient' && (
          <>
            <div style={styles.section}>
              <h3 style={styles.sectionHeader}>Personal Information</h3>
              <p><strong>Age:</strong> {fetchedData.age}</p>
              <p><strong>Gender:</strong> {fetchedData.gender}</p>
              <p><strong>Blood Type:</strong> {fetchedData.bloodType}</p>
            </div>

            <div style={styles.section}>
              <h3 style={styles.sectionHeader}>Medical Details</h3>
              <p><strong>Allergies:</strong> {fetchedData.allergies}</p>
              <p><strong>Diagnosis:</strong> {fetchedData.diagnosis}</p>
              <p><strong>Medications:</strong> {fetchedData.medications}</p>
            </div>

            <div style={styles.section}>
              <h3 style={styles.sectionHeader}>Visit Details</h3>
              <p><strong>Last Visit:</strong> {fetchedData.lastVisit}</p>
              <p><strong>Assigned Doctor:</strong> {fetchedData.doctorAssigned}</p>
            </div>
          </>
        )}

        {fetchedData.userType === 'Doctor' && (
          <div style={styles.section}>
            <h3 style={styles.sectionHeader}>Doctor Details</h3>
            <p><strong>Specialization:</strong> {fetchedData.doctorSpecialization}</p>
            <p><strong>Contact Number:</strong> {fetchedData.doctorContactNumber}</p>
            <p><strong>Address:</strong> {fetchedData.doctorAddress}</p>
            <p><strong>Email:</strong> {fetchedData.doctorEmail}</p>
            <p><strong>List of Operations:</strong> {fetchedData.doctorOperations}</p>
          </div>
        )}

        <div style={styles.footer}>
          <p><strong>Record Created At: </strong>{renderRecordCreatedAt()}</p>
        </div>
      </div>

      <div style={styles.actions}>
        <button style={styles.button} onClick={() => navigate(-1)}>← Back</button>
      </div>
    </div>
  );
}

// Styles
const styles = {
  container: {
    maxWidth: '800px',
    margin: '40px auto',
    padding: '30px',
    borderRadius: '12px',
    boxShadow: '0px 3px 12px rgba(0,0,0,0.1)',
    fontFamily: "'Segoe UI', Arial, sans-serif",
    backgroundColor: 'inherit',
    color: 'inherit',
  },
  header: {
    fontSize: '2rem',
    textAlign: 'center',
    marginBottom: '30px',
  },
  recordContainer: {
    backgroundColor: 'inherit',
    padding: '20px',
    borderRadius: '10px',
  },
  subHeader: {
    fontSize: '1.5rem',
    textAlign: 'center',
    fontWeight: '600',
    color: '#0077CC',
    marginBottom: '30px',
  },
  section: {
    marginBottom: '25px',
    padding: '15px',
    borderRadius: '8px',
    backgroundColor: 'rgba(0, 119, 204, 0.07)',
  },
  sectionHeader: {
    fontSize: '1.25rem',
    fontWeight: '600',
    borderBottom: '2px solid #0077CC',
    paddingBottom: '5px',
    marginBottom: '15px',
  },
  footer: {
    textAlign: 'center',
    fontSize: '0.9rem',
    color: 'gray',
    marginTop: '30px',
  },
  actions: {
    textAlign: 'center',
    marginTop: '30px',
  },
  button: {
    padding: '12px 25px',
    fontSize: '1rem',
    fontWeight: '600',
    borderRadius: '8px',
    backgroundColor: '#0077CC',
    color: 'white',
    cursor: 'pointer',
    border: 'none',
    transition: 'all 0.3s',
  },
};

export default MedicalRecordPage;
